/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AuditResponse } from '../api-models';
// @ts-ignore
import { HourAddRequestV2 } from '../api-models';
// @ts-ignore
import { HourDeleteRequestV2 } from '../api-models';
// @ts-ignore
import { HourDetailedAddRequestV2 } from '../api-models';
// @ts-ignore
import { HourDetailedResponseV2 } from '../api-models';
// @ts-ignore
import { HourDetailedUpdateRequestV2 } from '../api-models';
// @ts-ignore
import { HourMultiDeleteRequestV2 } from '../api-models';
// @ts-ignore
import { HourResponseV2 } from '../api-models';
// @ts-ignore
import { HourSummaryResponseV2 } from '../api-models';
// @ts-ignore
import { HourUpdateRequestV2 } from '../api-models';
// @ts-ignore
import { HoursDetailedBulkAddRequestV2 } from '../api-models';
// @ts-ignore
import { OtherHourUpdateRequestV2 } from '../api-models';
// @ts-ignore
import { OtherHoursConfigurationResponseV2 } from '../api-models';
// @ts-ignore
import { OtherHoursPayTypeConfigurationResponseV2 } from '../api-models';
// @ts-ignore
import { ProblemDetails } from '../api-models';
/**
 * HourV2Api - axios parameter creator
 * @export
 */
export const HourV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the audit trail for a single Hours row. Replaces taApi  `GET /api/Hour/Audits`. Throws 404 when the hour row doesn\'t belong to the employee.
         * @param {number} employeeId 
         * @param {number} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourAuditsGet: async (employeeId: number, recordId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('apiV2HourAuditsGet', 'employeeId', employeeId)
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('apiV2HourAuditsGet', 'recordId', recordId)
            const localVarPath = `/api/v2/hour/audits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (recordId !== undefined) {
                localVarQueryParameter['recordId'] = recordId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Daily summary of an employee\'s hours, grouped by pay-type / shift / labor levels / etc.  Replaces taApi `GET /api/Hour/DailySummary`.
         * @param {number} employeeId 
         * @param {string} payDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourDailySummaryGet: async (employeeId: number, payDate: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('apiV2HourDailySummaryGet', 'employeeId', employeeId)
            // verify required parameter 'payDate' is not null or undefined
            assertParamExists('apiV2HourDailySummaryGet', 'payDate', payDate)
            const localVarPath = `/api/v2/hour/daily-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (payDate !== undefined) {
                localVarQueryParameter['payDate'] = (payDate as any instanceof Date) ?
                    (payDate as any).toISOString() :
                    payDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft-delete a single Hours row scoped to the supplied employee. Replaces taApi  `DELETE /api/Hour`.
         * @param {HourDeleteRequestV2} [hourDeleteRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourDelete: async (hourDeleteRequestV2?: HourDeleteRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/hour`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hourDeleteRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk-insert multiple detailed Hours rows for a single employee, returns the  number that were actually inserted (skipped rows for closed pay periods don\'t count).  Replaces taApi `POST /api/Hour/HoursDetailed`.
         * @param {HoursDetailedBulkAddRequestV2} [hoursDetailedBulkAddRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourDetailsBulkPost: async (hoursDetailedBulkAddRequestV2?: HoursDetailedBulkAddRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/hour/details/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hoursDetailedBulkAddRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insert a fully-specified Hours row. Replaces taApi `POST /api/Hour/HoursDetailed`.
         * @param {HourDetailedAddRequestV2} [hourDetailedAddRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourDetailsPost: async (hourDetailedAddRequestV2?: HourDetailedAddRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/hour/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hourDetailedAddRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Full update of a Hours row including labor levels, comment, amount. Replaces  taApi `PUT /api/Hour/HourDetailed`.
         * @param {HourDetailedUpdateRequestV2} [hourDetailedUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourDetailsPut: async (hourDetailedUpdateRequestV2?: HourDetailedUpdateRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/hour/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hourDetailedUpdateRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List the employee\'s Hours rows in the supplied date range (working pay period  when null). Replaces taApi `GET /api/Hour`.
         * @param {number} employeeId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourGet: async (employeeId: number, startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('apiV2HourGet', 'employeeId', employeeId)
            const localVarPath = `/api/v2/hour`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft-delete multiple Hours rows. Replaces taApi `DELETE /api/Hour/Hours`.
         * @param {HourMultiDeleteRequestV2} [hourMultiDeleteRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourMultiDelete: async (hourMultiDeleteRequestV2?: HourMultiDeleteRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/hour/multi`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hourMultiDeleteRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update one Other Hours row. Replaces taApi `PUT /api/Hour/OtherHour`.
         * @param {OtherHourUpdateRequestV2} [otherHourUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourOtherHourPut: async (otherHourUpdateRequestV2?: OtherHourUpdateRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/hour/other-hour`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(otherHourUpdateRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Configuration & permission flags driving the Other Hours UI for one employee.  Replaces taApi `GET /api/Hour/OtherHoursConfiguration/{employeeId}`.
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourOtherHoursConfigurationEmployeeIdGet: async (employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('apiV2HourOtherHoursConfigurationEmployeeIdGet', 'employeeId', employeeId)
            const localVarPath = `/api/v2/hour/other-hours/configuration/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List \"Other\" Hours rows where ActualDate differs from PayDate. Replaces taApi  `GET /api/Hour/OtherHoursForActualDate`.
         * @param {number} employeeId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourOtherHoursForActualDateGet: async (employeeId: number, startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('apiV2HourOtherHoursForActualDateGet', 'employeeId', employeeId)
            const localVarPath = `/api/v2/hour/other-hours-for-actual-date`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List \"Other\" Hours rows. When hideWorkedHour is true, the  worked categories (Punches/AutoHours/OtherHoursWorked/Overtime variants) are filtered  out. Replaces taApi `GET /api/Hour/OtherHours`.
         * @param {number} employeeId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {boolean} [hideWorkedHour] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourOtherHoursGet: async (employeeId: number, startDate?: string, endDate?: string, hideWorkedHour?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('apiV2HourOtherHoursGet', 'employeeId', employeeId)
            const localVarPath = `/api/v2/hour/other-hours`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (hideWorkedHour !== undefined) {
                localVarQueryParameter['hideWorkedHour'] = hideWorkedHour;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Defaults for an Other Hours row when a specific PayType is selected.  Replaces taApi `GET /api/Hour/OtherHoursPayTypeConfiguration`.
         * @param {number} [employeeId] 
         * @param {number} [payTypeId] 
         * @param {string} [payDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourOtherHoursPayTypeConfigurationGet: async (employeeId?: number, payTypeId?: number, payDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/hour/other-hours/pay-type-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (payTypeId !== undefined) {
                localVarQueryParameter['payTypeId'] = payTypeId;
            }

            if (payDate !== undefined) {
                localVarQueryParameter['payDate'] = (payDate as any instanceof Date) ?
                    (payDate as any).toISOString() :
                    payDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pay-period summary of an employee\'s hours, grouped by pay-type and the configured  department labor level. Replaces taApi `GET /api/Hour/PayPeriodSummary`.
         * @param {number} employeeId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourPayPeriodSummaryGet: async (employeeId: number, startDate: string, endDate: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('apiV2HourPayPeriodSummaryGet', 'employeeId', employeeId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('apiV2HourPayPeriodSummaryGet', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('apiV2HourPayPeriodSummaryGet', 'endDate', endDate)
            const localVarPath = `/api/v2/hour/pay-period-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insert a basic Hours row (no labor levels / comment / amount). Replaces taApi  `POST /api/Hour`.
         * @param {HourAddRequestV2} [hourAddRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourPost: async (hourAddRequestV2?: HourAddRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/hour`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hourAddRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a Hours row\'s basic fields (PayType, Shift, Minutes). Replaces taApi  `PUT /api/Hour`.
         * @param {HourUpdateRequestV2} [hourUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourPut: async (hourUpdateRequestV2?: HourUpdateRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/hour`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hourUpdateRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HourV2Api - functional programming interface
 * @export
 */
export const HourV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HourV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns the audit trail for a single Hours row. Replaces taApi  `GET /api/Hour/Audits`. Throws 404 when the hour row doesn\'t belong to the employee.
         * @param {number} employeeId 
         * @param {number} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2HourAuditsGet(employeeId: number, recordId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2HourAuditsGet(employeeId, recordId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Daily summary of an employee\'s hours, grouped by pay-type / shift / labor levels / etc.  Replaces taApi `GET /api/Hour/DailySummary`.
         * @param {number} employeeId 
         * @param {string} payDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2HourDailySummaryGet(employeeId: number, payDate: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HourSummaryResponseV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2HourDailySummaryGet(employeeId, payDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Soft-delete a single Hours row scoped to the supplied employee. Replaces taApi  `DELETE /api/Hour`.
         * @param {HourDeleteRequestV2} [hourDeleteRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2HourDelete(hourDeleteRequestV2?: HourDeleteRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2HourDelete(hourDeleteRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Bulk-insert multiple detailed Hours rows for a single employee, returns the  number that were actually inserted (skipped rows for closed pay periods don\'t count).  Replaces taApi `POST /api/Hour/HoursDetailed`.
         * @param {HoursDetailedBulkAddRequestV2} [hoursDetailedBulkAddRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2HourDetailsBulkPost(hoursDetailedBulkAddRequestV2?: HoursDetailedBulkAddRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2HourDetailsBulkPost(hoursDetailedBulkAddRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Insert a fully-specified Hours row. Replaces taApi `POST /api/Hour/HoursDetailed`.
         * @param {HourDetailedAddRequestV2} [hourDetailedAddRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2HourDetailsPost(hourDetailedAddRequestV2?: HourDetailedAddRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2HourDetailsPost(hourDetailedAddRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Full update of a Hours row including labor levels, comment, amount. Replaces  taApi `PUT /api/Hour/HourDetailed`.
         * @param {HourDetailedUpdateRequestV2} [hourDetailedUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2HourDetailsPut(hourDetailedUpdateRequestV2?: HourDetailedUpdateRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2HourDetailsPut(hourDetailedUpdateRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List the employee\'s Hours rows in the supplied date range (working pay period  when null). Replaces taApi `GET /api/Hour`.
         * @param {number} employeeId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2HourGet(employeeId: number, startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HourResponseV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2HourGet(employeeId, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Soft-delete multiple Hours rows. Replaces taApi `DELETE /api/Hour/Hours`.
         * @param {HourMultiDeleteRequestV2} [hourMultiDeleteRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2HourMultiDelete(hourMultiDeleteRequestV2?: HourMultiDeleteRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2HourMultiDelete(hourMultiDeleteRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update one Other Hours row. Replaces taApi `PUT /api/Hour/OtherHour`.
         * @param {OtherHourUpdateRequestV2} [otherHourUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2HourOtherHourPut(otherHourUpdateRequestV2?: OtherHourUpdateRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2HourOtherHourPut(otherHourUpdateRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Configuration & permission flags driving the Other Hours UI for one employee.  Replaces taApi `GET /api/Hour/OtherHoursConfiguration/{employeeId}`.
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2HourOtherHoursConfigurationEmployeeIdGet(employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OtherHoursConfigurationResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2HourOtherHoursConfigurationEmployeeIdGet(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List \"Other\" Hours rows where ActualDate differs from PayDate. Replaces taApi  `GET /api/Hour/OtherHoursForActualDate`.
         * @param {number} employeeId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2HourOtherHoursForActualDateGet(employeeId: number, startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HourResponseV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2HourOtherHoursForActualDateGet(employeeId, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List \"Other\" Hours rows. When hideWorkedHour is true, the  worked categories (Punches/AutoHours/OtherHoursWorked/Overtime variants) are filtered  out. Replaces taApi `GET /api/Hour/OtherHours`.
         * @param {number} employeeId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {boolean} [hideWorkedHour] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2HourOtherHoursGet(employeeId: number, startDate?: string, endDate?: string, hideWorkedHour?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HourDetailedResponseV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2HourOtherHoursGet(employeeId, startDate, endDate, hideWorkedHour, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Defaults for an Other Hours row when a specific PayType is selected.  Replaces taApi `GET /api/Hour/OtherHoursPayTypeConfiguration`.
         * @param {number} [employeeId] 
         * @param {number} [payTypeId] 
         * @param {string} [payDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2HourOtherHoursPayTypeConfigurationGet(employeeId?: number, payTypeId?: number, payDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OtherHoursPayTypeConfigurationResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2HourOtherHoursPayTypeConfigurationGet(employeeId, payTypeId, payDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Pay-period summary of an employee\'s hours, grouped by pay-type and the configured  department labor level. Replaces taApi `GET /api/Hour/PayPeriodSummary`.
         * @param {number} employeeId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2HourPayPeriodSummaryGet(employeeId: number, startDate: string, endDate: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HourSummaryResponseV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2HourPayPeriodSummaryGet(employeeId, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Insert a basic Hours row (no labor levels / comment / amount). Replaces taApi  `POST /api/Hour`.
         * @param {HourAddRequestV2} [hourAddRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2HourPost(hourAddRequestV2?: HourAddRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2HourPost(hourAddRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a Hours row\'s basic fields (PayType, Shift, Minutes). Replaces taApi  `PUT /api/Hour`.
         * @param {HourUpdateRequestV2} [hourUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2HourPut(hourUpdateRequestV2?: HourUpdateRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2HourPut(hourUpdateRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HourV2Api - factory interface
 * @export
 */
export const HourV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HourV2ApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns the audit trail for a single Hours row. Replaces taApi  `GET /api/Hour/Audits`. Throws 404 when the hour row doesn\'t belong to the employee.
         * @param {HourV2ApiApiV2HourAuditsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourAuditsGet(requestParameters: HourV2ApiApiV2HourAuditsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AuditResponse>> {
            return localVarFp.apiV2HourAuditsGet(requestParameters.employeeId, requestParameters.recordId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Daily summary of an employee\'s hours, grouped by pay-type / shift / labor levels / etc.  Replaces taApi `GET /api/Hour/DailySummary`.
         * @param {HourV2ApiApiV2HourDailySummaryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourDailySummaryGet(requestParameters: HourV2ApiApiV2HourDailySummaryGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<HourSummaryResponseV2>> {
            return localVarFp.apiV2HourDailySummaryGet(requestParameters.employeeId, requestParameters.payDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft-delete a single Hours row scoped to the supplied employee. Replaces taApi  `DELETE /api/Hour`.
         * @param {HourV2ApiApiV2HourDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourDelete(requestParameters: HourV2ApiApiV2HourDeleteRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2HourDelete(requestParameters.hourDeleteRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk-insert multiple detailed Hours rows for a single employee, returns the  number that were actually inserted (skipped rows for closed pay periods don\'t count).  Replaces taApi `POST /api/Hour/HoursDetailed`.
         * @param {HourV2ApiApiV2HourDetailsBulkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourDetailsBulkPost(requestParameters: HourV2ApiApiV2HourDetailsBulkPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiV2HourDetailsBulkPost(requestParameters.hoursDetailedBulkAddRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insert a fully-specified Hours row. Replaces taApi `POST /api/Hour/HoursDetailed`.
         * @param {HourV2ApiApiV2HourDetailsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourDetailsPost(requestParameters: HourV2ApiApiV2HourDetailsPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiV2HourDetailsPost(requestParameters.hourDetailedAddRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Full update of a Hours row including labor levels, comment, amount. Replaces  taApi `PUT /api/Hour/HourDetailed`.
         * @param {HourV2ApiApiV2HourDetailsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourDetailsPut(requestParameters: HourV2ApiApiV2HourDetailsPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2HourDetailsPut(requestParameters.hourDetailedUpdateRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List the employee\'s Hours rows in the supplied date range (working pay period  when null). Replaces taApi `GET /api/Hour`.
         * @param {HourV2ApiApiV2HourGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourGet(requestParameters: HourV2ApiApiV2HourGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<HourResponseV2>> {
            return localVarFp.apiV2HourGet(requestParameters.employeeId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft-delete multiple Hours rows. Replaces taApi `DELETE /api/Hour/Hours`.
         * @param {HourV2ApiApiV2HourMultiDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourMultiDelete(requestParameters: HourV2ApiApiV2HourMultiDeleteRequest = {}, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiV2HourMultiDelete(requestParameters.hourMultiDeleteRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update one Other Hours row. Replaces taApi `PUT /api/Hour/OtherHour`.
         * @param {HourV2ApiApiV2HourOtherHourPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourOtherHourPut(requestParameters: HourV2ApiApiV2HourOtherHourPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2HourOtherHourPut(requestParameters.otherHourUpdateRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Configuration & permission flags driving the Other Hours UI for one employee.  Replaces taApi `GET /api/Hour/OtherHoursConfiguration/{employeeId}`.
         * @param {HourV2ApiApiV2HourOtherHoursConfigurationEmployeeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourOtherHoursConfigurationEmployeeIdGet(requestParameters: HourV2ApiApiV2HourOtherHoursConfigurationEmployeeIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<OtherHoursConfigurationResponseV2> {
            return localVarFp.apiV2HourOtherHoursConfigurationEmployeeIdGet(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List \"Other\" Hours rows where ActualDate differs from PayDate. Replaces taApi  `GET /api/Hour/OtherHoursForActualDate`.
         * @param {HourV2ApiApiV2HourOtherHoursForActualDateGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourOtherHoursForActualDateGet(requestParameters: HourV2ApiApiV2HourOtherHoursForActualDateGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<HourResponseV2>> {
            return localVarFp.apiV2HourOtherHoursForActualDateGet(requestParameters.employeeId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List \"Other\" Hours rows. When hideWorkedHour is true, the  worked categories (Punches/AutoHours/OtherHoursWorked/Overtime variants) are filtered  out. Replaces taApi `GET /api/Hour/OtherHours`.
         * @param {HourV2ApiApiV2HourOtherHoursGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourOtherHoursGet(requestParameters: HourV2ApiApiV2HourOtherHoursGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<HourDetailedResponseV2>> {
            return localVarFp.apiV2HourOtherHoursGet(requestParameters.employeeId, requestParameters.startDate, requestParameters.endDate, requestParameters.hideWorkedHour, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Defaults for an Other Hours row when a specific PayType is selected.  Replaces taApi `GET /api/Hour/OtherHoursPayTypeConfiguration`.
         * @param {HourV2ApiApiV2HourOtherHoursPayTypeConfigurationGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourOtherHoursPayTypeConfigurationGet(requestParameters: HourV2ApiApiV2HourOtherHoursPayTypeConfigurationGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<OtherHoursPayTypeConfigurationResponseV2> {
            return localVarFp.apiV2HourOtherHoursPayTypeConfigurationGet(requestParameters.employeeId, requestParameters.payTypeId, requestParameters.payDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Pay-period summary of an employee\'s hours, grouped by pay-type and the configured  department labor level. Replaces taApi `GET /api/Hour/PayPeriodSummary`.
         * @param {HourV2ApiApiV2HourPayPeriodSummaryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourPayPeriodSummaryGet(requestParameters: HourV2ApiApiV2HourPayPeriodSummaryGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<HourSummaryResponseV2>> {
            return localVarFp.apiV2HourPayPeriodSummaryGet(requestParameters.employeeId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insert a basic Hours row (no labor levels / comment / amount). Replaces taApi  `POST /api/Hour`.
         * @param {HourV2ApiApiV2HourPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourPost(requestParameters: HourV2ApiApiV2HourPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiV2HourPost(requestParameters.hourAddRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a Hours row\'s basic fields (PayType, Shift, Minutes). Replaces taApi  `PUT /api/Hour`.
         * @param {HourV2ApiApiV2HourPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2HourPut(requestParameters: HourV2ApiApiV2HourPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2HourPut(requestParameters.hourUpdateRequestV2, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV2HourAuditsGet operation in HourV2Api.
 * @export
 * @interface HourV2ApiApiV2HourAuditsGetRequest
 */
export interface HourV2ApiApiV2HourAuditsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HourV2ApiApiV2HourAuditsGet
     */
    readonly employeeId: number

    /**
     * 
     * @type {number}
     * @memberof HourV2ApiApiV2HourAuditsGet
     */
    readonly recordId: number
}

/**
 * Request parameters for apiV2HourDailySummaryGet operation in HourV2Api.
 * @export
 * @interface HourV2ApiApiV2HourDailySummaryGetRequest
 */
export interface HourV2ApiApiV2HourDailySummaryGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HourV2ApiApiV2HourDailySummaryGet
     */
    readonly employeeId: number

    /**
     * 
     * @type {string}
     * @memberof HourV2ApiApiV2HourDailySummaryGet
     */
    readonly payDate: string
}

/**
 * Request parameters for apiV2HourDelete operation in HourV2Api.
 * @export
 * @interface HourV2ApiApiV2HourDeleteRequest
 */
export interface HourV2ApiApiV2HourDeleteRequest {
    /**
     * 
     * @type {HourDeleteRequestV2}
     * @memberof HourV2ApiApiV2HourDelete
     */
    readonly hourDeleteRequestV2?: HourDeleteRequestV2
}

/**
 * Request parameters for apiV2HourDetailsBulkPost operation in HourV2Api.
 * @export
 * @interface HourV2ApiApiV2HourDetailsBulkPostRequest
 */
export interface HourV2ApiApiV2HourDetailsBulkPostRequest {
    /**
     * 
     * @type {HoursDetailedBulkAddRequestV2}
     * @memberof HourV2ApiApiV2HourDetailsBulkPost
     */
    readonly hoursDetailedBulkAddRequestV2?: HoursDetailedBulkAddRequestV2
}

/**
 * Request parameters for apiV2HourDetailsPost operation in HourV2Api.
 * @export
 * @interface HourV2ApiApiV2HourDetailsPostRequest
 */
export interface HourV2ApiApiV2HourDetailsPostRequest {
    /**
     * 
     * @type {HourDetailedAddRequestV2}
     * @memberof HourV2ApiApiV2HourDetailsPost
     */
    readonly hourDetailedAddRequestV2?: HourDetailedAddRequestV2
}

/**
 * Request parameters for apiV2HourDetailsPut operation in HourV2Api.
 * @export
 * @interface HourV2ApiApiV2HourDetailsPutRequest
 */
export interface HourV2ApiApiV2HourDetailsPutRequest {
    /**
     * 
     * @type {HourDetailedUpdateRequestV2}
     * @memberof HourV2ApiApiV2HourDetailsPut
     */
    readonly hourDetailedUpdateRequestV2?: HourDetailedUpdateRequestV2
}

/**
 * Request parameters for apiV2HourGet operation in HourV2Api.
 * @export
 * @interface HourV2ApiApiV2HourGetRequest
 */
export interface HourV2ApiApiV2HourGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HourV2ApiApiV2HourGet
     */
    readonly employeeId: number

    /**
     * 
     * @type {string}
     * @memberof HourV2ApiApiV2HourGet
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof HourV2ApiApiV2HourGet
     */
    readonly endDate?: string
}

/**
 * Request parameters for apiV2HourMultiDelete operation in HourV2Api.
 * @export
 * @interface HourV2ApiApiV2HourMultiDeleteRequest
 */
export interface HourV2ApiApiV2HourMultiDeleteRequest {
    /**
     * 
     * @type {HourMultiDeleteRequestV2}
     * @memberof HourV2ApiApiV2HourMultiDelete
     */
    readonly hourMultiDeleteRequestV2?: HourMultiDeleteRequestV2
}

/**
 * Request parameters for apiV2HourOtherHourPut operation in HourV2Api.
 * @export
 * @interface HourV2ApiApiV2HourOtherHourPutRequest
 */
export interface HourV2ApiApiV2HourOtherHourPutRequest {
    /**
     * 
     * @type {OtherHourUpdateRequestV2}
     * @memberof HourV2ApiApiV2HourOtherHourPut
     */
    readonly otherHourUpdateRequestV2?: OtherHourUpdateRequestV2
}

/**
 * Request parameters for apiV2HourOtherHoursConfigurationEmployeeIdGet operation in HourV2Api.
 * @export
 * @interface HourV2ApiApiV2HourOtherHoursConfigurationEmployeeIdGetRequest
 */
export interface HourV2ApiApiV2HourOtherHoursConfigurationEmployeeIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HourV2ApiApiV2HourOtherHoursConfigurationEmployeeIdGet
     */
    readonly employeeId: number
}

/**
 * Request parameters for apiV2HourOtherHoursForActualDateGet operation in HourV2Api.
 * @export
 * @interface HourV2ApiApiV2HourOtherHoursForActualDateGetRequest
 */
export interface HourV2ApiApiV2HourOtherHoursForActualDateGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HourV2ApiApiV2HourOtherHoursForActualDateGet
     */
    readonly employeeId: number

    /**
     * 
     * @type {string}
     * @memberof HourV2ApiApiV2HourOtherHoursForActualDateGet
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof HourV2ApiApiV2HourOtherHoursForActualDateGet
     */
    readonly endDate?: string
}

/**
 * Request parameters for apiV2HourOtherHoursGet operation in HourV2Api.
 * @export
 * @interface HourV2ApiApiV2HourOtherHoursGetRequest
 */
export interface HourV2ApiApiV2HourOtherHoursGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HourV2ApiApiV2HourOtherHoursGet
     */
    readonly employeeId: number

    /**
     * 
     * @type {string}
     * @memberof HourV2ApiApiV2HourOtherHoursGet
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof HourV2ApiApiV2HourOtherHoursGet
     */
    readonly endDate?: string

    /**
     * 
     * @type {boolean}
     * @memberof HourV2ApiApiV2HourOtherHoursGet
     */
    readonly hideWorkedHour?: boolean
}

/**
 * Request parameters for apiV2HourOtherHoursPayTypeConfigurationGet operation in HourV2Api.
 * @export
 * @interface HourV2ApiApiV2HourOtherHoursPayTypeConfigurationGetRequest
 */
export interface HourV2ApiApiV2HourOtherHoursPayTypeConfigurationGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HourV2ApiApiV2HourOtherHoursPayTypeConfigurationGet
     */
    readonly employeeId?: number

    /**
     * 
     * @type {number}
     * @memberof HourV2ApiApiV2HourOtherHoursPayTypeConfigurationGet
     */
    readonly payTypeId?: number

    /**
     * 
     * @type {string}
     * @memberof HourV2ApiApiV2HourOtherHoursPayTypeConfigurationGet
     */
    readonly payDate?: string
}

/**
 * Request parameters for apiV2HourPayPeriodSummaryGet operation in HourV2Api.
 * @export
 * @interface HourV2ApiApiV2HourPayPeriodSummaryGetRequest
 */
export interface HourV2ApiApiV2HourPayPeriodSummaryGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HourV2ApiApiV2HourPayPeriodSummaryGet
     */
    readonly employeeId: number

    /**
     * 
     * @type {string}
     * @memberof HourV2ApiApiV2HourPayPeriodSummaryGet
     */
    readonly startDate: string

    /**
     * 
     * @type {string}
     * @memberof HourV2ApiApiV2HourPayPeriodSummaryGet
     */
    readonly endDate: string
}

/**
 * Request parameters for apiV2HourPost operation in HourV2Api.
 * @export
 * @interface HourV2ApiApiV2HourPostRequest
 */
export interface HourV2ApiApiV2HourPostRequest {
    /**
     * 
     * @type {HourAddRequestV2}
     * @memberof HourV2ApiApiV2HourPost
     */
    readonly hourAddRequestV2?: HourAddRequestV2
}

/**
 * Request parameters for apiV2HourPut operation in HourV2Api.
 * @export
 * @interface HourV2ApiApiV2HourPutRequest
 */
export interface HourV2ApiApiV2HourPutRequest {
    /**
     * 
     * @type {HourUpdateRequestV2}
     * @memberof HourV2ApiApiV2HourPut
     */
    readonly hourUpdateRequestV2?: HourUpdateRequestV2
}

/**
 * HourV2Api - object-oriented interface
 * @export
 * @class HourV2Api
 * @extends {BaseAPI}
 */
export class HourV2Api extends BaseAPI {
    /**
     * 
     * @summary Returns the audit trail for a single Hours row. Replaces taApi  `GET /api/Hour/Audits`. Throws 404 when the hour row doesn\'t belong to the employee.
     * @param {HourV2ApiApiV2HourAuditsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HourV2Api
     */
    public apiV2HourAuditsGet(requestParameters: HourV2ApiApiV2HourAuditsGetRequest, options?: AxiosRequestConfig) {
        return HourV2ApiFp(this.configuration).apiV2HourAuditsGet(requestParameters.employeeId, requestParameters.recordId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Daily summary of an employee\'s hours, grouped by pay-type / shift / labor levels / etc.  Replaces taApi `GET /api/Hour/DailySummary`.
     * @param {HourV2ApiApiV2HourDailySummaryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HourV2Api
     */
    public apiV2HourDailySummaryGet(requestParameters: HourV2ApiApiV2HourDailySummaryGetRequest, options?: AxiosRequestConfig) {
        return HourV2ApiFp(this.configuration).apiV2HourDailySummaryGet(requestParameters.employeeId, requestParameters.payDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft-delete a single Hours row scoped to the supplied employee. Replaces taApi  `DELETE /api/Hour`.
     * @param {HourV2ApiApiV2HourDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HourV2Api
     */
    public apiV2HourDelete(requestParameters: HourV2ApiApiV2HourDeleteRequest = {}, options?: AxiosRequestConfig) {
        return HourV2ApiFp(this.configuration).apiV2HourDelete(requestParameters.hourDeleteRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk-insert multiple detailed Hours rows for a single employee, returns the  number that were actually inserted (skipped rows for closed pay periods don\'t count).  Replaces taApi `POST /api/Hour/HoursDetailed`.
     * @param {HourV2ApiApiV2HourDetailsBulkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HourV2Api
     */
    public apiV2HourDetailsBulkPost(requestParameters: HourV2ApiApiV2HourDetailsBulkPostRequest = {}, options?: AxiosRequestConfig) {
        return HourV2ApiFp(this.configuration).apiV2HourDetailsBulkPost(requestParameters.hoursDetailedBulkAddRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insert a fully-specified Hours row. Replaces taApi `POST /api/Hour/HoursDetailed`.
     * @param {HourV2ApiApiV2HourDetailsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HourV2Api
     */
    public apiV2HourDetailsPost(requestParameters: HourV2ApiApiV2HourDetailsPostRequest = {}, options?: AxiosRequestConfig) {
        return HourV2ApiFp(this.configuration).apiV2HourDetailsPost(requestParameters.hourDetailedAddRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Full update of a Hours row including labor levels, comment, amount. Replaces  taApi `PUT /api/Hour/HourDetailed`.
     * @param {HourV2ApiApiV2HourDetailsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HourV2Api
     */
    public apiV2HourDetailsPut(requestParameters: HourV2ApiApiV2HourDetailsPutRequest = {}, options?: AxiosRequestConfig) {
        return HourV2ApiFp(this.configuration).apiV2HourDetailsPut(requestParameters.hourDetailedUpdateRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List the employee\'s Hours rows in the supplied date range (working pay period  when null). Replaces taApi `GET /api/Hour`.
     * @param {HourV2ApiApiV2HourGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HourV2Api
     */
    public apiV2HourGet(requestParameters: HourV2ApiApiV2HourGetRequest, options?: AxiosRequestConfig) {
        return HourV2ApiFp(this.configuration).apiV2HourGet(requestParameters.employeeId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft-delete multiple Hours rows. Replaces taApi `DELETE /api/Hour/Hours`.
     * @param {HourV2ApiApiV2HourMultiDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HourV2Api
     */
    public apiV2HourMultiDelete(requestParameters: HourV2ApiApiV2HourMultiDeleteRequest = {}, options?: AxiosRequestConfig) {
        return HourV2ApiFp(this.configuration).apiV2HourMultiDelete(requestParameters.hourMultiDeleteRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update one Other Hours row. Replaces taApi `PUT /api/Hour/OtherHour`.
     * @param {HourV2ApiApiV2HourOtherHourPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HourV2Api
     */
    public apiV2HourOtherHourPut(requestParameters: HourV2ApiApiV2HourOtherHourPutRequest = {}, options?: AxiosRequestConfig) {
        return HourV2ApiFp(this.configuration).apiV2HourOtherHourPut(requestParameters.otherHourUpdateRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Configuration & permission flags driving the Other Hours UI for one employee.  Replaces taApi `GET /api/Hour/OtherHoursConfiguration/{employeeId}`.
     * @param {HourV2ApiApiV2HourOtherHoursConfigurationEmployeeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HourV2Api
     */
    public apiV2HourOtherHoursConfigurationEmployeeIdGet(requestParameters: HourV2ApiApiV2HourOtherHoursConfigurationEmployeeIdGetRequest, options?: AxiosRequestConfig) {
        return HourV2ApiFp(this.configuration).apiV2HourOtherHoursConfigurationEmployeeIdGet(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List \"Other\" Hours rows where ActualDate differs from PayDate. Replaces taApi  `GET /api/Hour/OtherHoursForActualDate`.
     * @param {HourV2ApiApiV2HourOtherHoursForActualDateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HourV2Api
     */
    public apiV2HourOtherHoursForActualDateGet(requestParameters: HourV2ApiApiV2HourOtherHoursForActualDateGetRequest, options?: AxiosRequestConfig) {
        return HourV2ApiFp(this.configuration).apiV2HourOtherHoursForActualDateGet(requestParameters.employeeId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List \"Other\" Hours rows. When hideWorkedHour is true, the  worked categories (Punches/AutoHours/OtherHoursWorked/Overtime variants) are filtered  out. Replaces taApi `GET /api/Hour/OtherHours`.
     * @param {HourV2ApiApiV2HourOtherHoursGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HourV2Api
     */
    public apiV2HourOtherHoursGet(requestParameters: HourV2ApiApiV2HourOtherHoursGetRequest, options?: AxiosRequestConfig) {
        return HourV2ApiFp(this.configuration).apiV2HourOtherHoursGet(requestParameters.employeeId, requestParameters.startDate, requestParameters.endDate, requestParameters.hideWorkedHour, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Defaults for an Other Hours row when a specific PayType is selected.  Replaces taApi `GET /api/Hour/OtherHoursPayTypeConfiguration`.
     * @param {HourV2ApiApiV2HourOtherHoursPayTypeConfigurationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HourV2Api
     */
    public apiV2HourOtherHoursPayTypeConfigurationGet(requestParameters: HourV2ApiApiV2HourOtherHoursPayTypeConfigurationGetRequest = {}, options?: AxiosRequestConfig) {
        return HourV2ApiFp(this.configuration).apiV2HourOtherHoursPayTypeConfigurationGet(requestParameters.employeeId, requestParameters.payTypeId, requestParameters.payDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Pay-period summary of an employee\'s hours, grouped by pay-type and the configured  department labor level. Replaces taApi `GET /api/Hour/PayPeriodSummary`.
     * @param {HourV2ApiApiV2HourPayPeriodSummaryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HourV2Api
     */
    public apiV2HourPayPeriodSummaryGet(requestParameters: HourV2ApiApiV2HourPayPeriodSummaryGetRequest, options?: AxiosRequestConfig) {
        return HourV2ApiFp(this.configuration).apiV2HourPayPeriodSummaryGet(requestParameters.employeeId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insert a basic Hours row (no labor levels / comment / amount). Replaces taApi  `POST /api/Hour`.
     * @param {HourV2ApiApiV2HourPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HourV2Api
     */
    public apiV2HourPost(requestParameters: HourV2ApiApiV2HourPostRequest = {}, options?: AxiosRequestConfig) {
        return HourV2ApiFp(this.configuration).apiV2HourPost(requestParameters.hourAddRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a Hours row\'s basic fields (PayType, Shift, Minutes). Replaces taApi  `PUT /api/Hour`.
     * @param {HourV2ApiApiV2HourPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HourV2Api
     */
    public apiV2HourPut(requestParameters: HourV2ApiApiV2HourPutRequest = {}, options?: AxiosRequestConfig) {
        return HourV2ApiFp(this.configuration).apiV2HourPut(requestParameters.hourUpdateRequestV2, options).then((request) => request(this.axios, this.basePath));
    }
}
